export enum BusinessEmploymentType {
  CDI = 'CDI',
  CDD = 'CDD',
  TEMPORARY = 'TEMPORARY',
  APPRENTICESHIP = 'APPRENTICESHIP',
}

export const getBusinessEmploymentTypeLabel = (object: BusinessEmploymentType) => {
  switch (object) {
    case BusinessEmploymentType.CDI:
      return $localize`CDI`;
    case BusinessEmploymentType.CDD:
      return $localize`CDD`;
    case BusinessEmploymentType.TEMPORARY:
      return $localize`Temporaire`;
    case BusinessEmploymentType.APPRENTICESHIP:
      return $localize`Apprentissage`;
    default:
      return '';
  }
};
